import { useEffect } from 'react';
import './headway.css';

const SCRIPT_ID = 'headway-widget-script';
const SCRIPT_SRC = 'https://cdn.headwayapp.co/widget.js';

const buildConfig = (onCount) => ({
  selector: '#headway-badge',
  trigger: '#headway-trigger',
  account: 'xbR0Bx',
  position: { x: 'right', y: 'top' },
  translations: {
    title: 'Novidades',
    readMore: 'Ler mais',
    labels: { new: 'Novo', improvement: 'Melhoria', fix: 'Correção' },
    footer: 'Ver todas as novidades',
  },
  callbacks: {
    onWidgetReady: (w) => onCount(w.getUnseenCount() || 0),
    onShowWidget: () => onCount(0),
  },
});

// Loads the Headway widget once (portal only) and re-inits on remount.
export const useHeadway = (enabled, onCount) => {
  useEffect(() => {
    if (!enabled) return undefined;
    window.HW_config = buildConfig(onCount);
    const existing = document.getElementById(SCRIPT_ID);
    if (window.Headway && typeof window.Headway.init === 'function') {
      try { window.Headway.init(window.HW_config); } catch (e) { /* widget unavailable */ }
    } else if (!existing) {
      const s = document.createElement('script');
      s.id = SCRIPT_ID;
      s.async = true;
      s.src = SCRIPT_SRC;
      s.onerror = () => { s.dataset.failed = '1'; };
      document.body.appendChild(s);
    }
    return () => {
      try { window.Headway?.hide?.(); window.Headway?.destroy?.(); } catch (e) { /* ignore */ }
    };
  }, [enabled, onCount]);
};

export const openHeadway = () => {
  try { window.Headway?.show?.(); } catch (e) { /* widget unavailable */ }
};
